import { useMutation, useQueryClient } from '@tanstack/react-query';
import { agentsApi, AIAgentResponse } from '../services/agentsApi';
import { toast } from 'sonner';

/**
 * Hook para duplicar um agente (#212). A cópia nasce inativa com nome
 * "{nome} (cópia)". Espelha useCreateAgent.
 *
 * @example
 * const duplicateAgent = useDuplicateAgent();
 * duplicateAgent.mutate(agentId);
 */
export const useDuplicateAgent = () => {
  const queryClient = useQueryClient();

  return useMutation<AIAgentResponse, Error, string>({
    mutationFn: (id) => agentsApi.duplicate(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ai-agents'] });
      toast.success('Agente duplicado com sucesso!');
    },
    onError: (error) => {
      toast.error(`Erro ao duplicar agente: ${error.message}`);
    },
  });
};
